import { render, staticRenderFns } from "./VContext.vue?vue&type=template&id=3e4d87b5&"
import script from "./VContext.vue?vue&type=script&lang=ts&"
export * from "./VContext.vue?vue&type=script&lang=ts&"
import style0 from "./VContext.vue?vue&type=style&index=0&id=3e4d87b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports